import React from 'react'
import { DefaultLayout } from '../../layouts'
import { SimplePageHeader } from '../../components'
import { MainContent } from './components'
import atf from '../../database/pages/atf.json'

const ResourceLanding = () => {
  return (
    <DefaultLayout>
      <SimplePageHeader
        title="Resources"
        description={atf.product}
        largePadding
      />
      <MainContent />
    </DefaultLayout>
  )
}

export { ResourceLanding }
